import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IDestinationProject } from '../types/IDestinationProject';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';

export interface IGetDestinationProjectParams extends IGetItemsParams {
  contentType: string;
  sourceIds?: string[];
}

export interface IGetDestinationProjectsResult extends IGetItemsResult {
  projects: IDestinationProject[];
}

export class GetDestinationProjectsRequest
    extends Request<IGetDestinationProjectParams, IGetDestinationProjectsResult> {
  constructor(params: IGetDestinationProjectParams) {
    super('getDestinationProjects', params);
  }
}
